<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงานรถเข้าซ่อม/ซ่อมเสร็จ</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'
                @onUserBranchNameChange='setCurrentBranchName'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container>
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                            <v-row>
                        <!-- <v-col cols="1"> สถานะ </v-col>  -->
                         <v-col cols="2">
                        <v-select
                            v-model="select"
                            :items="listStatus"
                            item-text="display"
                            item-value="value"
                            label="สถานะ"
                            persistent-hint
                            return-object
                            outlined></v-select>
                        </v-col>
                        </v-row>
                        <v-row>
                            <v-col><DatePicker label="ตั้งแต่ วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col><DatePicker label="ถึง วันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn  class="ma-2" color="primary" small target="_blank" @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                        </v-row>  
                        <v-row>
                            <v-col><b>จำนวนใบสั่งซ่อม : {{this.countBpj}} <span style="padding-left:20px ;">ค่าแรงหลังหักส่วนลดทั้งหมด : {{this.allSumServiceDisplay}} </span>
                                <span style="padding-left:20px ;">ค่าอะไหล่หลังหักส่วนลด : {{this.allSumPartsDisplay}} </span></b>  </v-col>
                        </v-row>          
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

         <template  width="1000px">
            <v-data-table 
                
                :headers="headers"
                :items="items"
                class="pt-5"
                >
            </v-data-table>
         </template>
        </v-card>       
    </v-container>
</template>

<script>

import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import DatePicker from '@/components/Shared/DatePicker'
import {listCarService,exportCarService} from '@/api/reports/report-api.js'
import numeral from 'numeral'
export default {
    name: 'CarService',
    components: {
        UserBranchDropdown,
        DatePicker
    },
   props:["pageCode"],
    data: () => ({
        select: { display: 'รถเข้าซ่อม', value: '1' },
        listStatus: [
            { display: 'รถเข้าซ่อม', value: '1' },
            { display: 'ซ่อมเสร็จ', value: '10' },
        ],
         headers: [
                        {text: "วันที่รับรถ", value: "strJobDate",width: "120px"},
                        {text: "วันที่รถเสร็จ", value: "strFinishDate",width: "120px"},
                        {text: "วันที่เปิด job", value: "strCreateDate",width: "120px"},
                        {text: "เลขที่ใบสั่งซ่อม", value: "jobNo",width: "150px"},
                        {text: "เลขที่ใบประเมิน", value: "estimateNo",width: "150px"},
                        {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo",width: "150px"},
                        {text: "ทะเบียน รุ่น สี", value: "car",width: "150px"},
                        {text: "ชิ้นงาน", value: "transCount",width: "100px"},
                        {text: "งาน", value: "jobSize",width: "100px"},
                        {text: "ประเภท", value: "jobType",width: "100px"},
                        {text: "ประกัน", value: "insurance",width: "100px"},
                        {text: "S/A", value: "empContact",width: "150px"},
                        {text: "วันที่นัดหมาย", value: "strAppointDate",width: "150px"},
                        {text: "ค่าแรง", value: "serviceTotalDisplay",width: "150px"},
                        {text: "ส่วนลดประกัน", value: "serviceDiscountDisplay",width: "150px"},
                        {text: "ค่าแรงหลังหักส่วนลด", value: "sumServiceDisplay",width: "150px"},
                        {text: "ค่าอะไหล่", value: "partsTotalDisplay",width: "150px"},
                        {text: "ส่วนลด", value: "partsDiscountDisplay",width: "150px"},
                        {text: "ค่าอะไหล่หลังหักส่วนลด", value: "sumPartsDisplay",width: "150px"},
                        {text: "งานนอก", value: "externalTotalDisplay",width: "150px"},
                        {text: "ยอดใบแจ้งหนี้", value: "invoiceAmountDisplay",width: "150px"}

                    ],
        items: [],
        selectStatus:'',
        countBpj: 0,
        allSumService: 0,
        allSumServiceDisplay: '0.00',
        allSumParts : 0.00,
        allSumPartsDisplay : '0.00',
    }),
    methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
            },
            setCurrentBranchName(branchName) {
                this.branchName = branchName;
            },
            search(){
                this.$loading(true);
                this.allSumService = 0;
                this.allSumParts = 0;
                listCarService(this.branchCode,this.select.value,this.dateFrom,this.dateTo).then(response => {
                this.items = response;
                 if (this.items) {
                this.items.forEach((e) => {
                    e.serviceTotalDisplay = numeral(e.serviceTotal).format('0,0.00');
                    e.serviceDiscountDisplay = numeral(e.serviceDiscount).format('0,0.00');
                   //sum sumService
                    this.allSumService += e.sumService;

                    this.allSumParts += e.sumParts;

                    e.sumServiceDisplay = numeral(e.sumService).format('0,0.00');
                    e.partsTotalDisplay = numeral(e.partsTotal).format('0,0.00');
                    e.partsDiscountDisplay = numeral(e.partsDiscount).format('0,0.00');
                    e.sumPartsDisplay = numeral(e.sumParts).format('0,0.00');
                    e.externalTotalDisplay = numeral(e.externalTotal).format('0,0.00');
                    e.invoiceAmountDisplay = numeral(e.invoiceAmount).format('0,0.00');
                    });
                    //check duplicate jobNo
                    const uniqueValues = new Set(this.items.map(v => v.jobNo));
                    this.countBpj = uniqueValues.size;
                    this.allSumServiceDisplay = numeral(this.allSumService).format('0,0.00');
                    this.allSumPartsDisplay = numeral(this.allSumParts).format('0,0.00');
                 }
                this.$loading(false);
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            createReport(){
                this.$loading(true);
                exportCarService(this.branchCode,this.branchName,this.select.value,this.dateFrom,this.dateTo);
                this.$loading(false);
            }
    }
}
</script>